import React, { createContext, useState, useContext } from "react";
import type { UserDetailInputAtUser } from "components/userModel";
import { getLocalDateString } from "components/dateUtil";

// Initial state for user detail
const initialUserDetail: UserDetailInputAtUser = {
  applicantName: "",
  applicantNameKana: "",
  birthDate: getLocalDateString(new Date()),
  age: 0,
  homePostalCode: "",
  homePrefecture: "",
  homeCity: "",
  homeAddress1: "",
  homeAddress2: "",
  homePhoneNumber: "",
  phoneNumber: "",
  faxNumber: "",
  mobileNumber: "",
  companyName: "",
  invoiceNumber: "",
  corporateNumber: "",
  postalCode: "",
  prefecture: "",
  city: "",
  address1: "",
  address2: "",
  industryType: "",
  annualSales: "",
  employeeCount: "",
  taxDelayType: "",
  taxDelayBalance: 0,
  taxDelayStatus: "",
  familyStructure: [{
    relationship: "",
    fullName: "",
    age: 0,
    contactInfo: "",
  }],
  factoringHistory: "",
  pastProviders: "",
  pastProviderAmount: 0,
  currentProviderHistory: "なし",
  currentProviders: "",
  currentProviderAmount: 0,
  personalInfoConsent: false,
};


// Define the context type
interface DetailRegisterContextType {
  userDetail: UserDetailInputAtUser;
  setUserDetail: React.Dispatch<React.SetStateAction<UserDetailInputAtUser>>;
  uploadedFiles: File[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  reset: () => void;
}

// Create the context with default values
const DetailRegisterContext = createContext<DetailRegisterContextType>({
  userDetail: initialUserDetail,
  setUserDetail: () => {},
  uploadedFiles: [],
  setUploadedFiles: () => {},
  reset: () => {},
});

// Create the provider component
export const DetailRegisterProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [userDetail, setUserDetail] = useState<UserDetailInputAtUser>(initialUserDetail);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const reset = () => {
    setUserDetail(initialUserDetail);
    setUploadedFiles([]);
  };

  return (
    <DetailRegisterContext.Provider
      value={{
        userDetail,
        setUserDetail,
        uploadedFiles,
        setUploadedFiles,
        reset,
      }}
    >
      {children}
    </DetailRegisterContext.Provider>
  );
};

// Custom hook to use the context
export const useDetailRegister = () => useContext(DetailRegisterContext);

// Export the initial state for reuse
export { initialUserDetail };
